var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocksloader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 201 188",
    height: 108,
    width: 108,
    style: {
      margin: "initial",
      display: "block",
      shapeRendering: "auto",
      background: "rgba(255, 255, 255, 0)"
    },
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "ldl-scale",
    style: {
      transformOrigin: "50% 50%",
      transform: "rotate(0deg) scale(0.8, 0.8)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transformBox: "view-box",
      opacity: 1,
      transformOrigin: "100.5px 94px",
      transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)",
      animation: "1s linear 0s infinite normal forwards running animate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M38.0399 130.239V56.1808L102.52 29.4234L73.8427 0.74585L12.1187 26.3595L0.56073 43.6665V158.301L26.4819 175.609L131.546 132.032L102.873 103.354L38.0399 130.239Z",
    style: {
      fill: "rgb(25, 25, 25)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M163.239 57.6921V131.75L98.755 158.508L127.433 187.185L189.157 161.572L200.715 144.265V29.6297L174.793 12.3189L69.7288 55.8995L98.4063 84.577L163.239 57.6921Z",
    style: {
      fill: "rgb(25, 25, 25)"
    }
  }))))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "@keyframes animate { 0.00% {animation-timing-function: cubic-bezier(0.51,0.03,0.89,0.56);transform: translate(0.00px,0.00px) rotate(0.00deg) scale(1.00, 1.00) skew(0deg, 0.00deg) ;opacity: 1.00;}52.00% {animation-timing-function: cubic-bezier(0.17,0.39,0.55,0.91);transform: translate(0.00px,0.00px) rotate(211.13deg) ;}100.00% {animation-timing-function: cubic-bezier(0.17,0.39,0.55,0.91);transform: translate(0.00px,0.00px) rotate(360.00deg) ;} }")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocksloader);
export default __webpack_public_path__ + "static/media/rocks loader.2a17dd2e28b31727faf8a774f662a305.svg";
export { ForwardRef as ReactComponent };